import { state } from '../state.js';
import { $ } from '../utils/dom.js';
import { fmtMoney, fmtInt, escapeHtml } from '../utils/format.js';
import { montoDisplay } from '../utils/currency.js';

let adQuery = '';
let searchBound = false;

export function renderAdTable() {
  const input = $('adSearch');
  if (input && !searchBound) {
    input.oninput = (e) => { adQuery = e.target.value; renderAdTable(); };
    searchBound = true;
  }

  const map = new Map();
  state.filtered.forEach((r) => {
    const k = (r.AD_ID || r.POST_ID || '(sin ID)') + (r.AD_ID && r.POST_ID ? ` · post ${r.POST_ID}` : '');
    if (!map.has(k)) map.set(k, { count: 0, total: 0 });
    const v = map.get(k);
    v.count++;
    v.total += montoDisplay(r);
  });
  const all = [...map.entries()].sort((a, b) => b[1].count - a[1].count);
  const t = $('adTable');
  if (!all.length || (all.length === 1 && all[0][0].startsWith('(sin ID)'))) {
    t.innerHTML = `<tbody><tr><td class="empty">No hay AD ID / POST ID en estos registros</td></tr></tbody>`;
    return;
  }
  const q = adQuery.trim().toLowerCase();
  const arr = q ? all.filter(([k]) => k.toLowerCase().includes(q)) : all;
  const body = arr.length
    ? arr.map(([k, v]) => `
      <tr><td>${escapeHtml(k)}</td><td class="num">${fmtInt(v.count)}</td><td class="num">${fmtMoney(v.total)}</td></tr>
    `).join('')
    : `<tr><td class="empty" colspan="3">Sin coincidencias para "${escapeHtml(adQuery.trim())}"</td></tr>`;
  t.innerHTML = `
    <thead><tr><th>AD / POST</th><th class="num">Ventas</th><th class="num">Monto</th></tr></thead>
    <tbody>${body}</tbody>`;
}
